import { useIntl } from 'react-intl';
import { Box, Stack, Typography } from '@packages/shared';
import { InstallmentValueTile } from '../InstallmentValueTile';
import { installmentValueTilesContainerMessages } from './messages';

export interface InstallmentValueTilesContainerProps {
  /**
   * a list of installments (actually viableInstallments in data)
   */
  installmentsList: number[];
  /**
   * the active installment (actually numberOfInstallments in data)
   */
  activeInstallment: number;
  /**
   * on click handler function
   */
  installmentSelectedHandler: (value: number) => void;
}

/**
 * installment value container atom
 *
 * a wrapper for InstallmentValueTile atoms
 *
 * */
export const InstallmentValueTilesContainer = ({
  installmentsList,
  activeInstallment,
  installmentSelectedHandler,
}: InstallmentValueTilesContainerProps) => {
  const { formatMessage } = useIntl();

  return (
    <Box>
      <Typography variant="body1" marginBottom={0.5}>
        {formatMessage(installmentValueTilesContainerMessages.headline)}
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {installmentsList.map((installmentValue) => (
          <InstallmentValueTile
            clickTrackingProps={{
              category: 'Ratenrechner',
              detail: `Monatsrate ${installmentValue.toString()}`,
              label: 'Kredit-Promo',
            }}
            value={installmentValue}
            active={installmentValue === activeInstallment}
            onClickHandler={installmentSelectedHandler}
            key={installmentValue}
          />
        ))}
      </Stack>
    </Box>
  );
};
